/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// Google Analytics Tracker
import Tracker from "useTracking.js"
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
// sections for this page
import SectionRefund from "views/RefundPage/Sections/SectionRefund.js";
import SectionEmailSubscription from "views/ContactUsPage/Sections/SubscribeLine.js";
import faqStyle from "assets/jss/material-kit-pro-react/views/faqStyle.js";

const useStyles = makeStyles(faqStyle);

export default function RefundPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    Tracker();
  });
  const getMonth = () => {
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const d = new Date();
    return monthNames[d.getMonth()];
  }
  const classes = useStyles();
  return (
    <div>
      <Header
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="white"
        changeColorOnScroll={{
          height: 300,
          color: "white"
        }}
      />
      <Parallax
        image={require("assets/img/headers/privacy.jpg")}
        small
        title="Refund Policy"
        description={`Last Updated ${getMonth()} ${(new Date().getFullYear())}`}
        // description="Last updated: May 15, 2025"
        backgroundPosition={"center center"} />
      <div className={classNames(classes.main)}>
        <div className={classes.container}>
          <SectionRefund />
        </div>
      </div>
      <SectionEmailSubscription />
      <Footer theme="white" />
    </div>
  );
}
